var map = {
	"./access-denied.png": "5e20",
	"./baker.png": "7fe1",
	"./bar.png": "ae83",
	"./board.png": "77a4",
	"./boards-sprite.png": "f96d",
	"./celular-station.png": "4df5",
	"./chatGPT.png": "3f6e",
	"./copy-icon.png": "bf06",
	"./cow.png": "3ef4",
	"./drag-n-drop.png": "9105",
	"./enmacc-logo.png": "606e",
	"./farm.png": "c6b8",
	"./file-icon.png": "349b",
	"./file.png": "eb1a",
	"./fruits.png": "b7f5",
	"./hairsalon5.png": "49d8",
	"./home-1.png": "34d9",
	"./modal-sprite.png": "a4d8",
	"./movie.png": "5c0e",
	"./office-building.png": "e9bb",
	"./profile.png": "b8f2",
	"./profiles.png": "7f3a",
	"./project-sprite.png": "5991",
	"./remove-both-block.png": "69b1",
	"./remove-false-block.png": "e0d7",
	"./remove-true-block.png": "7470",
	"./renewable.png": "44f9",
	"./shop.png": "6d88",
	"./slp-chart.png": "d1e5",
	"./solar.png": "dabe",
	"./soptim-logo.png": "e91c",
	"./tree-dots.png": "cd81",
	"./warehouse.png": "3788"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7016";